import { memo, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import { ContentCopyOutlined } from '@mui/icons-material';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { Icon } from '../icon';
import Tooltip from '../tooltip';
import { RADIUS } from '../../../styles/themes';
import { ToastNotificationContext } from '../toast-notification';

interface Props {
  value: string;
  valueForClipboard?: string;
  label: string;
  hasCopyBtn: boolean;
  hasPrefix?: boolean;
  prefix?: string;
  hasToastMessage?: boolean;
  toastMessage?: string;
  hasTooltipMessage?: boolean;
  toooltipMessage?: string;
}
const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  buttonContainer: {
    marginLeft: '8px',
    border: '1px solid #00683E',
    borderRadius: RADIUS.sm,
    cursor: 'pointer',
    height: '16px'
  },
  button: {
    display: 'flex',
    flexDirection: 'row',
    width: '43px',
    height: '16px',
    alignItems: 'center',
    paddingLeft: '4px',
    paddingRight: '4px',
    paddingTop: '2px',
    paddingBottom: '4px'
  },
  icon: {
    color: '#00683E',
    width: '11px',
    marginRight: '2px'
  },
  text: {
    fontWeight: '400',
    lineHeight: '12px',
    fontSize: '10px',
    color: '#00683E',
    marginTop: '3px',
    marginRight: '2px'
  }
}));

const DetailsWithButton = ({
  value,
  valueForClipboard,
  label,
  hasCopyBtn,
  hasPrefix,
  prefix,
  hasToastMessage,
  toastMessage,
  hasTooltipMessage,
  toooltipMessage
}: Props) => {
  const classes = useStyles();
  const { openToast } = useContext(ToastNotificationContext);
  const handleToastMessage = () => {
    if (hasToastMessage) {
      openToast({
        message: `${toastMessage}`,
        severity: 'success',
        autoHideDuration: 1000
      });
    } else {
      openToast({
        message: 'Copied to clipboard',
        severity: 'success',
        autoHideDuration: 1000
      });
    }
  };

  return (
    <>
      {hasCopyBtn ? (
        <Box mt={1}>
          <Box className={classes.container}>
            <Box>
              <Typography variant="body2">{label}</Typography>
            </Box>
            <Box className={classes.buttonContainer} onClick={handleToastMessage}>
              <Tooltip title={hasTooltipMessage ? `${toooltipMessage}` : 'Copy to clipboard'}>
                <Box>
                  <CopyToClipboard text={valueForClipboard || value}>
                    <Box className={classes.button}>
                      <Icon className={classes.icon} icon={ContentCopyOutlined} />
                      <Box className={classes.text}>Copy</Box>
                    </Box>
                  </CopyToClipboard>
                </Box>
              </Tooltip>
            </Box>
          </Box>
          <Box>
            <Typography variant="body1">{hasPrefix ? `${prefix}${value}` : `${value}`}</Typography>
          </Box>
        </Box>
      ) : (
        <Box mt={1}>
          <Box>
            <Typography variant="body2">{label}</Typography>
          </Box>
          <Box>
            <Typography variant="body1">{hasPrefix ? `${prefix}${value}` : `${value}`}</Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

export default memo(DetailsWithButton);
